import React, { useState, useEffect, useRef } from "react";
import { cn } from "../../../Utils/helper";
import images from "../../../images"; // Assuming FilterIcon is here

export function FormSelect({
  icon,
  options = [],
  value = "", // Single selected value (string)
  onChange,
  rightIcon,
  className,
  defaultValue,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleOptionClick = (optionValue) => {
    onChange({ target: { value: optionValue } }); // Update value with single selection
    setIsOpen(false); // Close dropdown after selection
  };

  // Display selected option or placeholder
  const displayText =
    value && options.find((opt) => opt.value === value)
      ? options.find((opt) => opt.value === value).label
      : defaultValue
      ? defaultValue
      : "Select an option";

  return (
    <div className="relative" ref={selectRef}>
      {/* Trigger Button */}
      <div
        className={cn(
          `flex gap-1.5 items-center px-1.5 py-2.5 w-full leading-none whitespace-nowrap bg-white rounded-xl border border-solid border-stone-200 min-h-[42px] cursor-pointer`,
          className
        )}
        onClick={() => setIsOpen(!isOpen)}
      >
        {icon && (
          <img
            loading="lazy"
            src={icon}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
          />
        )}
        <span className="flex-1 shrink self-stretch my-auto text-sm text-gray-600 truncate">
          {displayText}
        </span>
        <img
          loading="lazy"
          src={images.ChevronDownIcon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-transparent z-0"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10">
            {options.map((option) => (
              <div
                key={option.value}
                className={cn(
                  "px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 cursor-pointer",
                  value === option.value && "bg-gray-100" // Highlight selected option
                )}
                onClick={() => handleOptionClick(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
